import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-3 align-items-center mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "skipYes",
    class: "col-form-label"
  }, "はいを選択した場合")
], -1)
const _hoisted_3 = { class: "col-8" }
const _hoisted_4 = { class: "row g-3 align-items-center mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "skipNo",
    class: "col-form-label"
  }, "いいえを選択した場合")
], -1)
const _hoisted_6 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_select = _resolveComponent("input-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_input_select, {
          label: "はいを選択した場合",
          modelValue: _ctx.skip.yes,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.skip.yes) = $event)),
          options: _ctx.sections,
          text: "text",
          result: "sectionId"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_input_select, {
          label: "いいえを選択した場合",
          modelValue: _ctx.skip.no,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.skip.no) = $event)),
          options: _ctx.sections,
          text: "text",
          result: "sectionId"
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ], 64))
}